import moment from 'moment';
import { useState } from 'react';
import FormatPhoneNumber from '../../../shared/components/FormatPhoneNumber';
import { handleFocus } from '../../../utils';
import { deleteMAAAA000, postMAAAA000, putMAAAA000 } from '../../../services/Api';

const MAAAA001 = ({ closePopup, data }) => {
    const [payload, setPayload] = useState({
        memberPass: '',
        nameKor: data?.nameKor || '',
        memberID: data?.memberID || '',
        residentNo: data?.residentNo ? moment(data?.residentNo, 'YYMMDD').format('YYYY.MM.DD') : '',
        telNo: data?.telNo || '',
        mobileNo: data?.mobileNo || '',
        email: data?.email || '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        if (payload.memberID === '' && !data?.seq) {
            alert('아이디를 입력해주세요.');
            handleFocus('memberID');
            return;
        } else if (payload.memberPass === '' && !data?.seq) {
            alert('비밀번호를 입력해주세요.');
            handleFocus('memberPass');
            return;
        } else if (payload.nameKor === '') {
            alert('이름을 입력해주세요.');
            handleFocus('nameKor');
            return;
        } else if (payload.mobileNo === '') {
            alert('휴대폰 번호를 입력해주세요.');
            handleFocus('mobileNo');
            return;
        } else if (payload.email === '') {
            alert('이메일을 입력해주세요.');
            handleFocus('email');
            return;
        }

        const formatedResidentNo = moment(payload.residentNo, 'YYYY.MM.DD').format('YYMMDD');
        const formatedTelNo = FormatPhoneNumber(payload.telNo);
        const formatedMobileNo = FormatPhoneNumber(payload.mobileNo);

        let payloadToSend = {
            ...payload,
            residentNo: formatedResidentNo,
            telNo: formatedTelNo,
            mobileNo: formatedMobileNo,
        };

        if (data?.seq) {
            payloadToSend = {
                ...payloadToSend,
                seq: data.seq,
            };
            putMAAAA000(payloadToSend)
                .then(() => {
                    alert('완료되었습니다.');
                    closePopup();
                })
                .catch((error) => console.log(error));
        } else {
            postMAAAA000(payloadToSend)
                .then(() => {
                    alert('완료되었습니다');
                    closePopup();
                })
                .catch((error) => {
                    if (error.response) {
                        const message = error.response.data;

                        if (message === 'Error memberID duplicate.') {
                            alert('이미 사용 중인 회원 아이디입니다.');
                        } else {
                            alert(message || '오류발생했습니다.');
                        }
                    } else {
                        alert('오류발생했습니다.');
                    }

                    console.log(error);
                });
        }
    };

    const handleDelete = () => {
        window.confirm('삭제하시겠습니까?') &&
            deleteMAAAA000(data?.seq)
                .then(() => {
                    alert('삭제되었습니다.');
                    closePopup();
                })
                .catch((error) => console.log(error));
    };

    return (
        <div id="popup" className="manager-admin-account">
            <div className="overlay" />
            <div className="popup-content">
                <div className="popup-close" onClick={closePopup} />
                <div className="popup-title">{data?.seq ? '관리자 정보 수정' : '관리자 등록'}</div>
                <div className="form-group-tickets">
                    <div className="form-group-left" style={{ width: '150px' }}>
                        <div className="title-form">아이디</div>
                        <div className="title-form">비밀번호</div>
                        <div className="title-form">이름</div>
                        {/* <div className="title-form">생년월일</div> */}
                        {/* <div className="title-form">연락처</div> */}
                        <div className="title-form">휴대폰 번호</div>
                        <div className="title-form">이메일</div>
                    </div>
                    <div className="form-group-right">
                        <div className="item-form">
                            {data?.seq ? (
                                <span>{data?.memberID}</span>
                            ) : (
                                <input
                                    type="text"
                                    value={payload?.memberID}
                                    name="memberID"
                                    onChange={handleChange}
                                    style={{ width: 300 }}
                                />
                            )}
                        </div>
                        <div className="item-form">
                            <input
                                type="password"
                                value={payload?.memberPass}
                                name="memberPass"
                                onChange={handleChange}
                                style={{ width: 300 }}
                            />
                        </div>
                        <div className="item-form">
                            <input
                                type="text"
                                name="nameKor"
                                value={payload?.nameKor}
                                onChange={handleChange}
                                style={{ width: 300 }}
                            />
                        </div>
                        {/* <div className="item-form">
                            <input
                                type="text"
                                name="residentNo"
                                value={payload?.residentNo}
                                onChange={handleChange}
                                style={{ width: 300 }}
                            />
                        </div> */}
                        {/* <div className="item-form">
                            <input
                                type="text"
                                value={FormatPhoneNumber(payload?.telNo)}
                                name="telNo"
                                onChange={handleChange}
                                style={{ width: 300 }}
                            />
                        </div> */}
                        <div className="item-form">
                            <input
                                type="text"
                                value={FormatPhoneNumber(payload?.mobileNo)}
                                name="mobileNo"
                                onChange={handleChange}
                                style={{ width: 300 }}
                            />
                        </div>
                        <div className="item-form">
                            <input
                                type="text"
                                value={payload?.email}
                                name="email"
                                onChange={handleChange}
                                style={{ width: 300 }}
                            />
                        </div>
                    </div>
                </div>
                <div className="group-button center">
                    <button className="popup-button" onClick={handleSave}>
                        {data?.seq ? '저장' : '등록'}
                    </button>
                    {data?.seq && (
                        <button className="popup-button" onClick={() => handleDelete(data?.seq)}>
                            삭제
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
export default MAAAA001;
